import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { showErrors } from '../../modules/general';
import { apiFetch, apiSearch } from '../../modules/utility';
const apiBase = 'sanYsidroBol';

const mapStateToProps = (state, ownProps) => {
	let sanYsidroBols;
	let sanYsidroBol;
	let sanYsidroBolId;

	if (state.lists.sanYsidroBolIds) {
		sanYsidroBols = _.map(state.lists.sanYsidroBolIds, (id) => state.maps.sanYsidroBol[id]);
	}

	if (ownProps.sanYsidroBol) {
		sanYsidroBol = ownProps.sanYsidroBol;
	} else {
		sanYsidroBolId = ownProps.sanYsidroBolId
			? ownProps.sanYsidroBolId
			: _.get(ownProps, ['match', 'params', 'sanYsidroBolId']);
		sanYsidroBol = _.get(state.maps, ['sanYsidroBol', sanYsidroBolId]);
	}

	return {
		sanYsidroBol,
		sanYsidroBols,
		authUser: state.auth.authUser,
		userMap: state.maps.user,
		resourceMap: state.maps.resource,
		stationDeliveryMap: state.maps.stationDelivery,
		bulkDeliveryMap: state.maps.bulkDelivery,
		stationMap: state.maps.station,
		terminalMap: state.maps.terminal,
	};
};

const search = (p = {}) => {
	const { afterDateTime, callback = _.noop } = p;
	return (dispatch) => {
		apiSearch({
			base: apiBase,
			params: {
				afterDateTime,
			},
			dispatch,
			callback,
		});
	};
};

const uploadBol = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.uploadBol`,
			params,
			dispatch,
			callback,
		});
	};
};

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			sanYsidroBolSearch: search,
			sanYsidroBolUpload: uploadBol,
			showErrors,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
